<!-- header of the modal -->
<div class="modal-header">
    <h3 class="modal-title">Domestic Headers
        <i (click)="cancel()" class="fa fa-times pull-right"></i>
		<i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px" (click)="minimise=!minimise"></i>
    </h3>
</div>
<div class="modal-body no-modal-body-scroll" [class.collapsed]="minimise">
  	  	@if (entityList && getEntityListKeys().length > 0) {
<table class="table table-bordered form-inline enityDetails">
    		<tr>
			@for (key of getEntityListKeys(); track $index) {
<td>
				<span>{{key}}</span>
			</td>
}
		</tr>
		<tr>
			@for (value of getEntityListValues(); track $index) {
<td>
				<span>{{value}}</span>
			</td>
}
		</tr>
	</table>
}

<!-- body of the modal -->

    <!-- <uib-tabset  type="pills" active="ctrl.activeTab">
        <uib-tab style ="margin-bottom: 15px;" index="$index + 1" classes="btn-sm" ng-repeat="tab in ctrl.tabs" heading="{{tab.name}}" disable="tab.disabled" ng-click="ctrl.assignTabNames(tab.name);">
            <div class="col-md-12" ng-include="tab.url"></div>
        </uib-tab>
    </uib-tabset> -->


 @if (formList && formList.length > 0) {
<table class="table table-bordered form-inline enityDetails">
	<thead>
		<tr>
			<th id="FD1120LPC_LINENO_CRUD_1" class="sticky-col">Line No</th>
			<th id="FD1120LPC_DESC_CRUD_2" class="sticky-col">Description</th>
			<th id="FD1120LPC_HEADER_CRUD_3" class="sticky-col">Values</th>
		</tr>
	</thead>
	 <tbody>
		@for (row of formList; track $index; let i = $index) {
<tr class="formDataBlock">
			 <td>{{row.LINE_NO}}</td>
			 <td>{{row.LINE_DESCRIPTION}}</td>
			 @if (row.EDIT_TYPE == 'checkbox') {
<td>
				<div style="padding-left: 25px">
					<input type="checkbox" 
						   [checked]="row.ATTRIB_VALUE === 'true'"
						   [disabled]="row.conditionalField"
						   (change)="onCheckboxChange(row, $event)">
				</div>
			</td>
}
			@if (row.EDIT_TYPE == 'currency') {
<td>
				<input id="Header_NO" 
					   class="form-control input-md numText"
					   style="text-align: right" 
					   type="text"
					   onlyDigits
					   [(ngModel)]="row.ATTRIB_VALUE"
					   [disabled]="row.is_editable"
					   placeholder=""
					   aria-describedby="basic-addon2">
			</td>
}
			<!-- <td style="width: 183px; text-align: left; padding-right: 10px;" *ngIf="row.EDIT_TYPE == 'radio'">
				<div *ngFor="let row1 of formList | filter: { EDIT_TYPE : 'radio' }; trackBy: trackByFn" *ngIf="row1.EDIT_TYPE == 'radio' && row1.FORM_LINE_KEY== row.FORM_LINE_KEY">
					<input id="CRDRADIO_{{activeTab}}_CRUD_{{i + 1}}" 
						   type="checkbox" 
						   [(ngModel)]="row1.ATTRIB_VALUE" 
						   [value]="'true'"
						   (change)="checkBoxHandler(row1.FORM_LINE_KEY,row1.LINE_ATTRIB_KEY,row2.ATTRIB_COL)">
					{{row1.ATTRIB_DESCRIPTION}}
				</div>
			</td> -->
			@if (row.EDIT_TYPE == 'radio') {
<td style="width: 183px; text-align: left; padding-right: 10px;">
				<input class="radio-inline" 
					   type="radio" 
					   [(ngModel)]="row.ATTRIB_VALUE" 
					   value="Yes" 
					   [disabled]="row.conditionalField"
					   required> Yes
				<input class="radio-inline" 
					   type="radio" 
					   [(ngModel)]="row.ATTRIB_VALUE" 
					   value="No"  
					   [disabled]="row.conditionalField"
					   required> No
			</td>
}
		</tr>
}
	</tbody>
</table>
}

<!-- Show loading message when data is being fetched -->
@if (showFormLoader) {
<div class="text-center p-4">
    <i class="fa fa-spinner fa-spin"></i> Loading form data...
</div>
}

<!-- Show message when no data is available -->
@if (!showFormLoader && (!formList || formList.length === 0)) {
<div class="text-center p-4">
    <p>No form data available.</p>
</div>
}

</div>
<!-- Footer for modal -->
<div class="modal-footer" [class.collapsed]="minimise">
    <button class="btn btn-info btn-sm" 
			type="button" 
			[disabled]="isSaveClicked" 
			(click)="save(currentTabName)">
   		 @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
    </button>
    @if (currentTabName != 'Subsidiary') {
<button 
			class="btn btn-danger-outline btn-sm" 
			type="button" 
			(click)="reset()">Reset</button>
}
    <button class="btn btn-warning btn-sm" 
			type="button" 
			(click)="cancel()">Cancel</button>
</div>
